import { render, staticRenderFns } from "./GalleryManageHotelList.vue?vue&type=template&id=640bede8&scoped=true"
import script from "./GalleryManageHotelList.vue?vue&type=script&lang=js"
export * from "./GalleryManageHotelList.vue?vue&type=script&lang=js"
import style0 from "./GalleryManageHotelList.vue?vue&type=style&index=0&id=640bede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bede8",
  null
  
)

export default component.exports